/* =========================================
   ISL LAB - Add to cart label with price
   "Ajouter au panier • 58 €"
   Works with:
   - Custom pills (.variant-pill) that you click
   - Shopify variant radios/selects
   - Horizon variant events if present
========================================= */

(function () {
  function formatEuroFromCents(cents) {
    const euros = Math.round((Number(cents) || 0) / 100);
    return `${euros} €`;
  }

  function findAddToCartButton(scope) {
    // Try common selectors (your custom + theme)
    return (
      (scope || document).querySelector(".add-to-cart") ||
      (scope || document).querySelector('[ref="addToCartButton"]') ||
      (scope || document).querySelector('button[name="add"]') ||
      (scope || document).querySelector(".product-form__submit")
    );
  }

  function setButtonLabel(priceText, scope) {
    const btn = findAddToCartButton(scope);
    if (!btn) return;

    // If spans exist (recommended)
    const priceEl = btn.querySelector("#btn-price") || btn.querySelector(".btn-price");
    const textEl = btn.querySelector(".btn-text");

    if (priceEl) priceEl.textContent = priceText;

    // If user didn't add spans, fallback (keeps it simple)
    if (!priceEl && !textEl) {
      btn.textContent = `Ajouter au panier • ${priceText}`;
    }
  }

  function getVariantPriceFromPill(pill) {
    // pill data-price is in cents (you used that earlier)
    const cents = Number(pill?.dataset?.price);
    if (!Number.isFinite(cents)) return null;
    return formatEuroFromCents(cents);
  }

  function initFromFirstPill() {
    const firstActive = document.querySelector(".variant-pill.active") || document.querySelector(".variant-pill");
    if (!firstActive) return;
    const price = getVariantPriceFromPill(firstActive);
    if (price) setButtonLabel(price);
  }

  // 1) Your custom pills (click)
  document.addEventListener("click", function (e) {
    const pill = e.target.closest && e.target.closest(".variant-pill");
    if (!pill) return;

    const price = getVariantPriceFromPill(pill);
    if (price) setButtonLabel(price);
  });

  // 2) Shopify default variant radios/selects (change)
  document.addEventListener("change", function (e) {
    const el = e.target;

    // If theme uses radios/selects, price is usually updated elsewhere,
    // but we can still catch variant id changes if needed.
    if (!el) return;

    // If your button has #btn-price, we try to pull current displayed product price
    // (works with many themes)
    if (
      el.matches('select[name="id"]') ||
      el.matches('input[name="id"]') ||
      el.matches('input[type="radio"]')
    ) {
      const priceNode =
        document.querySelector("[data-product-price]") ||
        document.querySelector(".price") ||
        document.querySelector(".product__price") ||
        document.querySelector("[data-price]");

      if (priceNode) {
        const txt = (priceNode.textContent || "").trim();
        if (txt) setButtonLabel(txt);
      }
    }
  });

  // 3) Horizon / theme custom event (if it exists)
  // Some Horizon builds dispatch ThemeEvents.variantUpdate or a CustomEvent
  document.addEventListener("variant:change", function (event) {
    const v = event?.detail?.variant;
    if (!v) return;
    setButtonLabel(formatEuroFromCents(v.price));
  });

  // 4) If Horizon exposes ThemeEvents (optional)
  document.addEventListener("theme:variant:update", function (event) {
    const v = event?.detail?.variant;
    if (!v) return;
    setButtonLabel(formatEuroFromCents(v.price));
  });

  // Init on load
  document.addEventListener("DOMContentLoaded", function () {
    initFromFirstPill();
  });
})();